import { useSprintMutation, useSprintQueryClient, SprintMutationResult } from "sprint-common-web";

import { ApproveCloudFileNotificationsRequest } from "../../../../../../../common/api/master-api/cloud-files/approve-notifications/ApproveCloudFileNotificationsRequest";
import { useCloudFileApi } from "../../../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CloudFileQueryKey } from "../../../../common/CloudFileQueryKey";

export interface UseApproveCloudFileNotifications {
    approveCloudFileNotifications: SprintMutationResult<ApproveCloudFileNotificationsRequest, void>;
}

export const useApproveCloudFileNotifications = ({
    invalidationKey
}: {
    invalidationKey?: string;
}): UseApproveCloudFileNotifications => {
    const cloudFileApi = useCloudFileApi();
    const sprintQueryClient = useSprintQueryClient();

    const approveCloudFileNotifications = useSprintMutation<ApproveCloudFileNotificationsRequest>({
        mutationFn: async ({ cloudFileId }: ApproveCloudFileNotificationsRequest) => {
            if (!cloudFileId) {
                throw new Error("Cloud File ID is required to approve buzz notifications.");
            }

            return cloudFileApi.approveCloudFileNotifications({ cloudFileId });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [CloudFileQueryKey.CloudFileDetails, invalidationKey]
            });
        }
    });

    return {
        approveCloudFileNotifications
    };
};
